import { render } from "./PagePieChart.vue?vue&type=template&id=44779934&scoped=true"
import script from "./PagePieChart.vue?vue&type=script&lang=js"
export * from "./PagePieChart.vue?vue&type=script&lang=js"

import "./PagePieChart.vue?vue&type=style&index=0&id=44779934&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44779934"]])

export default __exports__